export const UNSET_KIND_PSUEDO_DUID = "@unset";
export const UNSET_KIND_LABEL = "(Unset)";

export const ENTITY_KIND_URL = "url";
